import { render, staticRenderFns } from "./TelcoFormGeneral.vue?vue&type=template&id=ae92eb2c&"
import script from "./TelcoFormGeneral.vue?vue&type=script&lang=ts&"
export * from "./TelcoFormGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ae92eb2c', component.options)
    } else {
      api.reload('ae92eb2c', component.options)
    }
    module.hot.accept("./TelcoFormGeneral.vue?vue&type=template&id=ae92eb2c&", function () {
      api.rerender('ae92eb2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MantenedorTelco/MantenedorTelcoEditar/TelcoFormGeneral.vue"
export default component.exports